
import { createLogger } from '@core/utils/console'
import LocalStorage from './local_storage'
import localforage from 'localforage'
import PropTypes from 'prop-types'
import moment from 'moment'
import React from 'react'

export { LocalStorageContext, useLocalStorageContext } from './local_storage'

const logAction = createLogger('pink')

const LocalStorageContainer = (props) => {

  const name = props.name || 'local'
  const storeName = props.storeName || 'cache'

  const client = localforage.createInstance({
    name,
    storeName
  })

  const get = ({ key, onSuccess, onFailure }) => {

    client.getItem(key, (err, result) => {

      const value = result?.value || null

      if(err) {
        logAction('local_storage/GET_FAILURE', { key, err })
        return onFailure(err)
      }

      if(!result?.expires_at) {
        logAction('local_storage/GET_SUCCESS', { key, value })
        return onSuccess(value)  
      }

      if(!moment().isAfter(moment(value.expires_at, 'x'))) {
        logAction('local_storage/GET_SUCCESS', { key, value })
        return onSuccess(value)  
      }

      client.removeItem(key, (err) => {

        if(err) {
          logAction('local_storage/GET_FAILURE', { key, err })
          return onFailure(err)
        }

        logAction('local_storage/GET_EXPIRED', { key })
        onSuccess(null)

      })

    })

  }

  const remove = ({ key, onSuccess, onFailure }) => {

    client.removeItem(key, (err) => {

      if(err) {
        logAction('local_storage/REMOVE_FAILURE', { key, err })
        return onFailure(err)
      }

      logAction('local_storage/REMOVE_SUCCESS', { key })
      onSuccess()

    })

  }

  const set = (params) => {

    const { key, onSuccess, onFailure } = params

    const expires_at = params.expires_at || (params.expires_in ? moment().add(params.expires_in, 'seconds').format('x') : null)

    const value = {
      value: params.value,
      ...expires_at ? { expires_at } : {}
    }

    client.setItem(key, value, (err) => {

      if(err) {
        logAction('local_storage/SET_FAILURE', { key, value: value.value, err })
        return onFailure(err)
      }

      logAction('local_storage/SET_SUCCESS', { key, expires_at, value: value.value })
      onSuccess(value.value)

    })

  }

  const mergedProps = {
    ...props,
    get,
    remove,
    set
  }

  return <LocalStorage { ...mergedProps }/>

}

LocalStorageContainer.propTypes = {
  name: PropTypes.string,
  storeName: PropTypes.string
}

export default LocalStorageContainer